import { FixedBraces } from "./fixed-braces";
import { LingualBraces } from "./lingual-braces";
import { ClearAligners } from "./clear-aligners";
import { RemovableAppliance } from "./removable-appliance";
import { FunctionalAppliance } from "./functional-appliance";
import { CosmeticOrthodontics } from "./cosmetic-orthodontics";
import { Retainer } from "./retainer";
import { MiniImplants } from "./mini-implants";
import { Traction } from "./traction";

export const treatments = [
  FixedBraces,
  LingualBraces,
  ClearAligners,
  RemovableAppliance,
  FunctionalAppliance,
  CosmeticOrthodontics,
  Retainer,
  MiniImplants,
  Traction,
];



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/ortho/index.ts